// extracted by mini-css-extract-plugin
module.exports = {"loginBtn":"MsLoginButton_loginBtn__2S99E","microsoftLoginBtn":"MsLoginButton_microsoftLoginBtn__qovZf"};